import { Helmet } from "react-helmet";
import PortalSection from "../../PortalSection";

export default function TopTableGames() {
  const curDate = new Date();

  const topPar = {
    h2: `Top Table Games in the UK (${curDate.getFullYear()} Edition)`,
    p: "Table games bring the thrill of the casino floor straight to your screen — combining skill, strategy, and just the right amount of luck. Whether you're a Blackjack master or a Roulette spinner, we've got you covered.",
  };

  const par2 = {
    id: "par-2",
    h4: "🧠 Tips for Winning at Table Games",
    ul: [
      "🎯 Blackjack Strategy Cards can cut house edge to <1%",
      "🔢 Roulette: European (single zero) version has better odds than American",
      "💼 Bankroll Management is key — don't chase losses",
      "🧑‍💻 Try Live Dealer versions for realism and social interaction",
    ],
  };

  const par3 = {
    id: "par-3",
    h4: "📱 Play Anywhere",
    p: "All listed casinos offer mobile-optimized experiences, so you can enjoy table games from your phone, tablet, or desktop — no app required.",
  };

  const par4 = {
    id: "par-4",
    h4: "🏁 Final Word",
    ul: [
      "✅ Wide variety of classic & modern table games",
      "✅ Realistic gameplay with live dealers & HD streams",
      "✅ Bonuses tailored for table players",
    ],
  };

  const meta = {
    title: `Top Table Games in UK Casinos: Play & Win Big in  ${curDate.getFullYear()}`,
    description: `Explore the best crash games in UK casinos for ${curDate.getFullYear()}. Discover thrilling gameplay, top titles like Aviator and Space Crash, and tips to maximize your wins. Play safely and responsibly!"`,
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <PortalSection />
      <div className="w-100 text-bg-dark text-white pt-5 pb-5 mt-3 information">
        <div>
          <h2>{topPar.h2}</h2>
          <p>{topPar.p}</p>
        </div>

        <div>
          <table className="top-table">
            <thead>
              <tr>
                <th>Table Game</th>
                <th>How to Play</th>
                <th>Why UK Players Love It</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Blackjack</td>
                <td>Beat the dealer by getting 21 or less</td>
                <td>Fast-paced, low house edge</td>
              </tr>
              <tr>
                <td>Roulette</td>
                <td>Bet where the ball will land on the wheel</td>
                <td>Iconic, social, big win potential</td>
              </tr>
              <tr>
                <td>Baccarat</td>
                <td>Bet on Player, Banker or Tie</td>
                <td>Simple rules, high-roller appeal</td>
              </tr>
              <tr>
                <td>Casino Hold'em</td>
                <td>Beat the dealer's poker hand</td>
                <td>Combines poker and table gameplay</td>
              </tr>
              <tr>
                <td>Craps</td>
                <td>Bet on dice rolls and sequences</td>
                <td>Energetic, big crowd favourite</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id={par2.id} className="mt-4">
          <h4>{par2.h4}</h4>
          <p>
            {par2.ul.map((li, i) => {
              const [title, text] = li.split(":");
              return (
                <li key={i}>
                  <b>{title}: </b>
                  {text}
                </li>
              );
            })}
          </p>
        </div>

        <div id={par3.id} className="mt-4">
          <h4>{par3.h4}</h4>
          <p>{par3.p}</p>
        </div>

        <div id={par4.id} className="mt-4">
          <h4>{par4.h4}</h4>
          <p>{par4.p}</p>
          <ul>
            {par4.ul.map((li, i) => (
              <li key={i}>{li}</li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
